import React from 'react';
import { Button } from 'antd';
import classes from './buttons.module.css';

const MyButton = (props) => {
    return (
        <Button {...props} className={classes.myButton}>
            <span>{props.children}</span>
        </Button>
    );
};

MyButton.propTypes = {
    ...Button.propTypes, // Use Ant Design Button propTypes
};

export default MyButton;